import { useEffect, useState } from 'react';

export function useDebounce<T>(
  value: T,
  delay: number = 500,
  onChange: ((value: T) => void) | undefined = undefined
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      onChange?.(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
